import { gql } from '@apollo/client';

export const assessmentEnglishContentAreaFragment = gql`
  fragment AssessmentEnglishContentAreaFragment on Assessment {
    data {
      englishContentArea
    }
  }
`;

export const UPDATE_ASSESSMENT_ENGLISH_CONTENT_AREAS = gql`
  mutation UpdateAssessmentEnglishContentAreas(
    $input: UpdateAssessmentEnglishContentAreaInput!
  ) {
    updateAssessmentEnglishContentArea(input: $input) {
      id
      ...AssessmentEnglishContentAreaFragment
    }
  }
  ${assessmentEnglishContentAreaFragment}
`;
